/*
  RBN selected-photo cart confirmation.
  On product pages and Quick Add: captures the visible gallery image after checking
  that the gallery's current colour agrees with the Shopify variant selection.
  The photo is presentation metadata, never a replacement for the variant ID.
*/
(function () {
  'use strict';
  // Read the color from the SAME product picker as the Add to Cart button.
  // Quick Add lives outside #MainContent, and can have a different selection.
  function selectedColor(root) {
    if (!root) return '';
    var pickers = root.querySelectorAll('variant-picker');
    for (var p = 0; p < pickers.length; p++) {
      var checked = pickers[p].querySelectorAll('[data-option-name]:checked, select[data-option-name]');
      for (var i = 0; i < checked.length; i++) {
        var el = checked[i];
        var name = (el.dataset.optionName || '').toLowerCase();
        if (name === 'color' || name === 'colour') return String(el.value || '').trim().toLowerCase();
      }
    }
    return '';
  }

  function allowedPhoto(value) {
    try {
      var u = new URL(value, location.href);
      if (u.protocol !== 'https:') return '';
      var hostname = u.hostname.toLowerCase();
      var isShopify = hostname === 'cdn.shopify.com' && u.pathname.indexOf('/s/files/') === 0;
      var isStore = (hostname === 'www.rudebynature.store' || hostname === 'rudebynature.store')
        && u.pathname.indexOf('/cdn/shop/files/') === 0;
      if (!isShopify && !isStore) return '';
      u.hash = '';
      // The saved image is shown only as a small cart thumbnail.
      // Ask the Shopify CDN for 320px rather than reusing a 1200–2048px gallery asset.
      u.searchParams.set('width', '320');
      return u.href;
    } catch (e) { return ''; }
  }
  // Restore the configured variant photo if a saved gallery image stops loading.
  document.addEventListener('error', function (event) {
    var img = event.target;
    if (!img || !img.matches || !img.matches('img[data-rbn-cart-fallback]')) return;
    var fallback = img.dataset.rbnCartFallback;
    delete img.dataset.rbnCartFallback;
    if (fallback) img.src = fallback;
  }, true);
  window.RBNCartPhoto = {
    capture: function (source, expectedColor) {
      if (!source || !source.closest) return null;
      // Quick Add is a dialog outside the homepage content.
      // Never capture a photo from the background product card.
      var quickAdd = source.closest('#quick-add-dialog');
      var root = null;
      if (quickAdd) {
        var dialog = quickAdd.querySelector('dialog.quick-add-modal');
        if (!dialog || !dialog.open) return null;
        root = quickAdd.querySelector('#quick-add-modal-content');
        if (!root || !root.contains(source)) return null;
      } else {
        if (source.closest('dialog, quick-add-dialog, quick-add-modal, product-card')) return null;
        root = source.closest('#MainContent');
        if (!root || !/^product(?:\\.|$)/.test(root.dataset.template || '')) return null;
      }
      var pickedColor = selectedColor(root);
      var color = String(expectedColor || pickedColor).trim().toLowerCase();
      if (!color || (pickedColor && color !== pickedColor)) return null;
      var gallery = root.querySelector('media-gallery[data-rbn-cart-color]');
      // Variant change may not have updated the gallery yet.
      // Never store a view from the wrong colour.
      if (!gallery || String(gallery.dataset.rbnCartColor || '').trim().toLowerCase() !== color) return null;
      var slide = null;
      var slideshow = gallery.slideshow;
      if (slideshow && slideshow.slides && Number.isInteger(slideshow.current)) {
        slide = slideshow.slides[slideshow.current];
      }
      if (!slide) slide = gallery.querySelector('slideshow-slide[aria-hidden="false"]');
      if (!slide) return null;
      var img = slide.querySelector('.product-media__image');
      if (!img) return null;
      var url = allowedPhoto(img.currentSrc || img.src || '');
      if (!url) return null;
      // Keep any selected view (front/side/man/woman) without changing variant.
      return { url: url, color: color };
    }
  };
})();
